import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: any[], filterString: string, propName:string):any[] {
    // console.log(propName);
    const result:any=[];
    if(!value || filterString==='' || propName===''){
      return value;
    }
    else{
      value.forEach((a)=>{
        if(a[propName].toLowerCase().includes(filterString.toLowerCase())){
          result.push(a)
        }
      }) 
    }
  return result;
  }

}
